/** Busy indicator. `role="status"` so screen readers announce the wait instead of silence. */
export function Spinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="spinner" role="status" aria-live="polite">
      <span className="spinner__dot" aria-hidden="true" />
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
